import { constantTree } from "../../../core/events/ConstantTree";

export const bookItAgainTree = constantTree({
    BookItAgainInit: "",
    Modal: {
        Show: ""
    },
    Calender: {
        BestPrice: ""
    },
    Round: {
        OutBound: {
            Continue: {
                Click: ""
            }
        },
        InBound: {
            Continue: {
                Click: ""
            }
        }
    },
    Continue: {
        Click: ""
    },
    Date: {
        Change: "",
        Click: ""
    },
    GetInterval: {
        Get: ""
    },
    BookItAgainUpcomingPastClick: ""
})